<template>
  <div>
    <v-toolbar color="pink" dark>
      <v-icon>list</v-icon>
      <v-toolbar-title>Player List</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-flex xs2>
          <v-text-field v-model="page.keywords" placeholder="Search for players" @keypress.enter="reload" invert clearable color="#FFF"></v-text-field>
      </v-flex>
     
      <v-tooltip bottom >
        <template slot="activator">
          <v-btn :to="{name:'register-player'}">
            <v-icon>add</v-icon>
          </v-btn>
        </template>
        <span>Register new Player</span>
      </v-tooltip>
       <v-tooltip bottom >
        <template slot="activator">
         <v-btn :href="playerListLink" target="_new">
            Full List
          </v-btn>
        </template>
        <span>Based on your network speed, this file might take several minutes to download.</span>
      </v-tooltip>
      
    </v-toolbar>
    <v-card>
      <v-data-table
        :loading="ui.loading"
        :headers="ui.headers"
        :items="players"
        class="elevation-1"
        :pagination.sync="page"
        :total-items="page.totalItems"
      >
        <template v-slot:items="props">
          <td>
            <v-avatar>
              <img :src="getAvatarUrl(props.item.id)" />
            </v-avatar>
          </td>
          <td>{{ props.item.registerNumber }} <span title="Hockey India Registration Number" v-if="props.item.hockeyIndiaRegNo">({{ props.item.hockeyIndiaRegNo }})</span></td>
          <td>{{ props.item.name }}</td>
          <td>{{props.item.dateOfBirth |formatDate }}</td>
          <td>{{ props.item.guardianName }}</td>
          <td>{{ props.item.gender }}</td>
          <td>{{ props.item.club.name }}</td>
          <td>
           <v-btn v-if="isAdmin" :to='{name:"player-editor",params:{id:props.item.id}}'>Edit Details</v-btn>
           <v-menu offset-x v-if="options.showDeleteOption">
              <template v-slot:activator="{ on }">
                <v-btn icon small v-on="on">
                  <v-icon>delete</v-icon>
                </v-btn>
              </template>
              <v-toolbar color="pink" dark>
                <v-icon>delete</v-icon>
                <v-toolbar-title>Confirm deletion</v-toolbar-title>
              </v-toolbar>
              <v-card>
                <v-card-title>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <div text-center>Are you sure you want to delete this record? This cannot be undone!</div>
                    </v-flex>
                  </v-layout>
                </v-card-title>
                <v-card-actions>
                  <v-btn block>No</v-btn>
                  <v-btn block @click="deletePlayer(props.item.id)">Yes</v-btn>
                </v-card-actions>
              </v-card>
            </v-menu>
          </td>
        </template>
      </v-data-table>
    </v-card>
     <v-snackbar auto-height v-model="ui.showAlert" color="error" :timeout="600000">
      <span>{{ui.feedback}}</span>
      <v-btn dark flat @click="ui.showAlert = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import _ from "underscore";
import moment from "moment";
import { mapState } from "vuex";

export default {
  data: function() {
    return {
      players: [],
      page: {
        page: 1,
        rowsPerPage: 10,
        totalItems: 0,
        hasNextPage: false,
        hasPreviousPage: false,
        keywords:"",
        descending:false,
        sortBy:""
      },
      ui: {
        loading:false,
        showAlert: false,
        feedback: "",
        headers: [
          {
            text: "",
            value: "",
            sortable: false,
            align: "left"
          },
          {
            text: "Reg No",
            value: "registerNumber",
            sortable: true,
            align: "left"
          },
          {
            text: "Name",
            value: "name",
            sortable: true,
            align: "left"
          },
          {
            text: "Date of Birth",
            value: "dateOfBirth",
            sortable: false,
            align: "left"
          },
          {
            text: "Guardian",
            value: "guardianName",
            sortable: false,
            align: "left"
          },
          {
            text: "Gender",
            value: "gender",
            sortable: false,
            align: "left"
          },
          {
            text: "Unit",
            value: "club.name",
            sortable: true,
            align: "left"
          },
          {
            text: "Options",
            sortable: false,
            align: "left"
          }
        ]
      }
    };
  },
  mounted: function() {
    this.reload();
  },
  methods: {
    reload: _.debounce(function() {
      var me = this;
      me.ui.loading=true;
      var args= _.pick(this.page,"page","descending","sortBy","keywords");
      args.pageSize=this.page.rowsPerPage;
      this.$api("players")
        .get(args)
        .then(resp => {
          me.players = resp.items;
          me.page = _.extend(me.page,_.omit(resp, "items"));
        })
        .catch(function() {
          
        }).finally(function(){
          me.ui.loading=false;
        });
    },500),
    getAvatarUrl:function(id){
        return this.meta.baseUrl+"/serve/profileimage/"+id+".jpg";
    },
    openPlayerForm:function(id){
      var url = this.meta.apiUrl + "/reports/playerbio/" + id+"?key="+this.identity.token;
      window.open(url);
    },
    deletePlayer: function(id) {
      var me = this;
      me.ui.feedback = "";
      me.ui.showAlert = false;
      this.$api("players/" + id)
        .delete()
        .then(function() {
          var index = _.findIndex(me.players, function(x) {
            return x.id == id;
          });
          if (index >= 0) {
            me.players.splice(index, 1);
          }
        })
        .catch(function(xhr) {
          if (xhr && xhr.responseJSON && xhr.responseJSON.feedback) {
            me.ui.feedback = xhr.responseJSON.feedback;
          } else {
            me.ui.feedback = "An error occured";
          }
          me.ui.showAlert = true;
        });
    }
  },
  filters: {
    formatDate: function(date) {
      return moment(date).format("DD-MMM-YYYY");
    },
    formatGender: function(i) {
      return ["Female", "Male"][i];
    },
    formatAgeGroup: function(i) {
      return ["Junior", "Sub Junior", "Senior"][i];
    }
  },
  watch: {
    "page.page": function(n, o) {
      if (n !== o) {
        this.reload();
      }
    },
    "page.rowsPerPage": function(n, o) {
      if (n !== o) {
      this.reload();
      }
    },
    "page.sortBy": function(n, o) {
      if (n !== o) {
        this.reload();
      }
    },
    "page.descending": function(n, o) {
      if (n !== o) {
        this.reload();
      }
    }
  },
  computed: {
    ...mapState("config", ["identity","meta","options"]),
    role: function() {
      return this.identity.type;
    },
    isAdmin: function() {
      return this.role == "Administrator";
    },
    isClub: function() {
      return this.role == "Club";
    },
    playerListLink:function(){
      return this.meta.apiUrl+"/players/list/all.pdf";
    }
  }
};
</script>